import { useEffect, useRef, useState } from "react";

export default function AboutSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="om-oss" ref={ref} className="py-24 md:py-40">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <div className={`transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="tracking-widest-2xl font-body uppercase text-primary mb-6" style={{ fontSize: "23px" }}>
              LYKKE NOMAD
            </p>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light leading-[1.1] mb-8 text-[#2a1810]">
              <span className="italic">Utviklet for nordisk klima og langsiktig verdi.</span>
            </h2>
            <div className="w-12 h-px bg-primary/40 mb-8" />
            <p className="text-foreground/70 mb-6 text-2xl font-body leading-relaxed max-w-lg">Vi bygger badstuer for nordisk klima, hvor vær, fukt og store temperatursvingninger stiller høye krav til både materialer og konstruksjon. Derfor jobber vi med naturlige materialer, gode detaljer og løsninger som holder over tid.

            </p>
            <p className="text-foreground/70 font-body leading-relaxed max-w-lg" style={{ fontSize: "23px" }}>Badstuene skal ikke bare se bra ut i landskapet, men også fungere godt i hverdagen og tåle mange år med bruk.

            </p>
            

            
          </div>

          <div
            className={`transition-all duration-1000 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="https://media.base44.com/images/public/69a726345560d5ef49a37111/7dda77270_IMG_9295.jpg"
                alt="LYKKE NOMAD Team"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1.5s]" />
              
            </div>
          </div>
        </div>
      </div>
    </section>);

}